/**
 * Created by lk on 17/6/4.
 */
import axios from "axios";
import https from "../../utils/http";
import { getToken, getAdminId } from "../../utils/auth";
let http = https.https;

// 获取列表
export function authRoleList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/role/index",
        method: "get",
        params: querys
    });
}

// 编辑
export function authRoleAuthList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/role/authList",
        method: "get",
        params: querys
    });
}

// 菜单编辑
export function authRoleMenuList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/menu/authList",
        method: "post",
        data: querys
    });
}

// 添加
export function authRoleAuth(data) {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/role/auth",
        method: "post",
        data: querys
    });
}

// 菜单添加
export function authRoleMenu(data) {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/menu/auth",
        method: "post",
        data: querys
    });
}

// 保存
export function authRoleSave(data, formName, method = "post") {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    let url =
        formName === "add"
            ? http + "/auth/role/save"
            : http + "/auth/role/edit";
    return axios({
        url: url,
        method: method,
        data: querys
    });
}

// 删除
export function authRoleDelete(data) {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/role/delete",
        method: "post",
        data: querys
    });
}
